<template>
  <span v-if="!size['x-small'] && !compact">
    <v-btn
      :id="id"
      v-bind="size"
      @click="onClick"
      :color="color"
      :outlined="outlined"
      :disabled="disabled"
      :loading="loading"
    >
      {{ label }}
    </v-btn>
  </span>
  <span v-else>
    <v-btn
      :id="id"
      size="small"
      @click="onClick"
      :icon="compact"
      :color="color"
      :outlined="outlined"
      :disabled="disabled"
      :loading="loading"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" size="x-large">{{ icon }}</v-icon>
        </template>
        <span>{{ tooltip ? tooltip : label }}</span>
      </v-tooltip>
    </v-btn>
  </span>
</template>

<script>
export default {
  name: "responsive-button",
  props: {
    id: {
      type: String,
    },
    disabled: {
      default: false,
    },
    outlined: {
      default: true,
    },
    color: {
      default: "primary",
    },
    label: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
      default: null,
    },
    icon: {
      required: true,
      type: String,
    },
    compact: {
      type: Boolean,
      required: false,
      default: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {};
  },

  computed: {
    size() {
      let size = {
        xs: "x-small",
        sm: "small",
        md: "small",
        lg: "medium",
        xl: "medium",
      }[this.$vuetify.breakpoint.name];
      if (this.small) {
        size = {
          xs: "x-small",
          sm: "small",
          md: "small",
          lg: "small",
          xl: "small",
        }[this.$vuetify.breakpoint.name];
      }
      return size ? { [size]: true } : {};
    },
  },
  watch: {},
  methods: {
    onClick() {
      this.$emit("onclick");
    },
  },
};
</script>
<style>
</style>

